export const TOGGLE_TOOLBAR = 'state.ui.top.title-bar.tool-bar.TOGGLE_TOOLBAR' as const;

export const toggleToolBar = () => ({
	type: TOGGLE_TOOLBAR,
});
